module.exports = __webpack_public_path__ + "img/02_yellow_talk.6c0a1e04.gif";